<template>
  <div>
    <div>添加同事</div>

    <div class="mt50">
      <el-input style="width: 336px" v-model="member_account" placeholder="请输入要添加的同事的手机号"></el-input>

      <el-button type="primary" style="width: 108px" @click="getMemberList" class="ml20">搜索</el-button>
    </div>
    <el-divider></el-divider>

    <!--        同事列表-->

    <div class="workmate-list">
      <div
        class="item fr jsb ac p20"
        style="border-bottom: 1px solid #e5e5e5"
        v-for="(item,index) in member_list"
        :key="index"
      >
        <div class="fr ac">
          <div>
            <img :src="item.member_img" style="width: 60px ;height: 60px;border-radius: 50%" alt />
          </div>
          <div class="ml20">
            <div>{{item.member_nick_name}}</div>
            <div class="mt20">{{item.member_account}}</div>
          </div>
        </div>

        <div>
          <el-button type="primary" @click="add(item)">添加</el-button>
        </div>
      </div>
    </div>

    <!--        指派职位弹窗-->
    <el-dialog center title="提示" :visible.sync="add_workmate_show" width="30%">
      <div class="fc jc ac">
        <img
          :src="current_member.member_img"
          style="width: 100px;height: 100px;border-radius: 50%"
          alt
        />
        <div class="mt10">{{current_member.member_nick_name}}</div>
        <div class="mt10">{{current_member.member_account}}</div>

        <div class="fr ac mt50">
          <div>职位</div>
          <div class="ml20">
            <el-select v-model="submit_form.role_id" placeholder="请选择">
              <el-option
                v-for="item in role_list"
                :key="item.role_id"
                :label="item.role_name"
                :value="item.role_id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="fr jc ac mt50">
        <el-button @click="submit" class="mt30" type="primary" style="width: 168px">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberInfo: this.$store.state.memberInfo,
      member_account: "",
      member_list: [],
      //    当前选择的用户
      current_member: {},
      add_workmate_show: false,

      //    添加同事弹出
      submit_form: {
        relation_id: "",
        auth_type: "",
        role_id: "",
        member_account: ""
      },
      //角色列表
      role_list: []
    };
  },
  mounted() {
    this.getMemberList();
    this.getMemberRoleList();
  },
  methods: {
    //    获取同事列表
    getMemberList() {
      let param = {
        member_account: this.member_account
      };
      if (!param.member_account) {
        this.member_list = [];
        return;
      }
      this.post("memberInterfaces/v1.0/getVisitorMemberList", param).then(
        res => {
          this.member_list = res.data;
          if (res.data.length == 0) {
            this.$message("未找到此用户");
            return;
          }
        }
      );
    },
    //    添加
    add(member) {
      this.add_workmate_show = true;
      this.current_member = member;
    },
    //获取角色列表
    getMemberRoleList() {
      let auth_type = "";
      let relation_id = "";

      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
      }

      let param = {
        role_type: auth_type
      };
      this.post("memberInterfaces/v1.0/getMemberRoles", param).then(res => {
        this.role_list = res.data;
      });
    },
    //    确认指派
    submit() {
      let memberInfo = this.memberInfo;
      let auth_type = "";
      let relation_id = "";

      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
      }

      let param = {
        member_account: this.current_member.member_account,
        relation_id: relation_id, //role_type 为2:买家用户id 3:供应商用户id 4:平台用户(-1)
        auth_type: auth_type, //2:买家用户 3:供应商用户 4:平台用户
        role_id: this.submit_form.role_id
      };

      if (!param.member_account) {
        this.$message("手机号为空");
        return;
      }
      if (!param.relation_id) {
        this.$message("relation_id为空 ");
        return;
      }
      if (!param.auth_type) {
        this.$message("auth_type为空");
        return;
      }

      if (!param.role_id) {
        this.$message("role_id为空");
        return;
      }

      //    添加同事
      this.post("memberInterfaces/v1.0/insertMemberAuth", param).then(res => {
        this.$message("添加成功");
        this.add_workmate_show = false;
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/page/me/workmate/add.vue